// extracted by mini-css-extract-plugin
export default {"btn-shine":"ScrollButton_btn-shine__CXPS4","shine":"ScrollButton_shine__aldAA","hide-btn":"ScrollButton_hide-btn__siCJs"};